import React from "react";
import { RecipientsViewModel } from "../../../domain/RecipientsViewModel";
import { ActionType } from "./types";
import { ManageRecipientsDialog } from "./dialogs/manageRecipients/ManageRecipientsDialog";
import { AssignUserDialog } from "./dialogs/AssignUserDialog";
import { CreateMessageDialog } from "./dialogs/CreateMessageDialog";
import { CloseDialog } from "./dialogs/CloseDialog";
import { InformationRequest } from "../../../domain/InformationRequest";

type RenderDialogProps = {
  focussedEntity: ActionType | null;
  onClose: () => void;
  recipients: RecipientsViewModel;
  informationRequest: InformationRequest;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
  focussedEntity,
  onClose,
  recipients,
  informationRequest,
}) => {
  if (!focussedEntity) {
    return null;
  }
  const actionType = focussedEntity as ActionType;

  switch (actionType) {
    case ActionType.ManageRecipients:
      return (
        <ManageRecipientsDialog onClose={onClose} recipients={recipients} />
      );
    case ActionType.AssignStaff:
      return <AssignUserDialog onClose={onClose} recipients={recipients} />;
    case ActionType.SendMessage:
      return (
        <CreateMessageDialog
          onClose={onClose}
          recipients={recipients}
          informationRequest={informationRequest}
        />
      );
    case ActionType.Close:
      return <CloseDialog onClose={onClose} recipients={recipients} />;
    default:
      return null;
  }
};
